module.exports = __webpack_public_path__ + "img/ge.63b03114.svg";